export function mockData() {
  return [
    {
      quiz_id: 2523235,
      title: 'Assessment | Fundamentals',
      post_name: 'assessment-fundamentals',
      category: 'preflop',
      subcategory: 'fundamentals',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2523295,
      title: 'Assessment | Preflop | 3-Betting 1',
      post_name: 'assessment-preflop-3-betting-1',
      category: 'preflop',
      subcategory: '3-betting-1',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525486,
      title: 'Assessment | Preflop | 3-Betting 2',
      post_name: 'assessment-preflop-3-betting-2',
      category: 'preflop',
      subcategory: '3-betting-2',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525518,
      title: 'Assessment | Preflop | 3-Betting 3',
      post_name: 'assessment-preflop-3-betting-3',
      category: 'preflop',
      subcategory: '3-betting-3',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525551,
      title: 'Assessment | Preflop | Bluffing',
      post_name: 'assessment-preflop-bluffing',
      category: 'preflop',
      subcategory: 'bluffing',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525584,
      title: 'Assessment | Preflop | Preflop Raise Sizes',
      post_name: 'assessment-preflop-preflop-raise-sizes',
      category: 'preflop',
      subcategory: 'preflop-raise-sizes',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525617,
      title: 'Assessment | Preflop | Facing a Raise',
      post_name: 'assessment-preflop-facing-a-raise',
      category: 'preflop',
      subcategory: 'facing-a-raise',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525650,
      title: 'Assessment | Preflop | Rake and Ante Effects',
      post_name: 'assessment-preflop-rake-and-ante-effects',
      category: 'preflop',
      subcategory: 'rake-and-ante-effects',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525683,
      title: 'Assessment | Preflop | Playing Against Limpers',
      post_name: 'assessment-preflop-playing-against-limpers',
      category: 'preflop',
      subcategory: 'playing-against-limpers',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525714,
      title: 'Assessment | Preflop | Multi-way Strategy',
      post_name: 'assessment-preflop-multi-way-strategy',
      category: 'preflop',
      subcategory: 'multiway-strategy',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525747,
      title: 'Assessment | Preflop | Preflop Short Stack Strategy',
      post_name: 'assessment-preflop-preflop-short-stack-strategy',
      category: 'preflop',
      subcategory: 'preflop-short-stack-strategy',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525779,
      title: 'Assessment | Preflop | Adjustments &#038; Exploits',
      post_name: 'assessment-preflop-adjustments-exploits',
      category: 'preflop',
      subcategory: 'adjustments-and-exploits',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525810,
      title: 'Assessment | Flop | Continuation Betting 1',
      post_name: 'assessment-flop-continuation-betting-1',
      category: 'flop',
      subcategory: 'continuation-betting-1',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525842,
      title: 'Assessment | Flop | Continuation Betting 2',
      post_name: 'assessment-flop-continuation-betting-2',
      category: 'flop',
      subcategory: 'continuation-betting-2',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525875,
      title: 'Assessment | Flop | Range Advantage',
      post_name: 'assessment-flop-range-advantage',
      category: 'flop',
      subcategory: 'range-advantage',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525906,
      title: 'Assessment | Flop | Nut Advantage',
      post_name: 'assessment-flop-nut-advantage',
      category: 'flop',
      subcategory: 'nut-advantage',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525938,
      title: 'Assessment | Flop | Stack Size Effects',
      post_name: 'assessment-flop-stack-size-effects',
      category: 'flop',
      subcategory: 'stack-size-effects',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2525969,
      title: 'Assessment | Flop | Dynamic Flops',
      post_name: 'assessment-flop-dynamic-flops',
      category: 'flop',
      subcategory: 'dynamic-flops',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526002,
      title: 'Assessment | Flop | Playing Out of Position',
      post_name: 'assessment-flop-playing-out-of-position',
      category: 'flop',
      subcategory: 'playing-out-of-position',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526035,
      title: 'Assessment | Flop | Check-Raising',
      post_name: 'assessment-flop-check-raising',
      category: 'flop',
      subcategory: 'check-raising',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526067,
      title: 'Assessment | Flop | Facing a Flop Raise',
      post_name: 'assessment-flop-facing-a-flop-raise',
      category: 'flop',
      subcategory: 'facing-a-flop-raise',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526098,
      title: 'Assessment | Flop | Playing Against Calling Stations',
      post_name: 'assessment-flop-playing-against-calling-stations',
      category: 'flop',
      subcategory: 'playing-against-calling-stations',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526134,
      title: 'Assessment | Flop | Multi-way Strategy',
      post_name: 'assessment-flop-multi-way-strategy',
      category: 'flop',
      subcategory: 'multiway-strategy-flop',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526166,
      title: 'Assessment | Turn | Continuation Betting 1',
      post_name: 'assessment-turn-continuation-betting-1',
      category: 'turn',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526197,
      title: 'Assessment | Turn | Continuation Betting 2',
      post_name: 'assessment-turn-continuation-betting-2',
      category: 'turn',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526230,
      title: 'Assessment | Turn | Continuation Betting 3',
      post_name: 'assessment-turn-continuation-betting-3',
      category: 'turn',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526263,
      title: 'Assessment | Turn | Range and Nut Advantage',
      post_name: 'assessment-turn-range-and-nut-advantage',
      category: 'turn',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526328,
      title: 'Assessment | Turn | Leading',
      post_name: 'assessment-turn-leading',
      category: 'turn',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526361,
      title: 'Assessment | Turn | Facing a Turn Lead',
      post_name: 'assessment-turn-facing-a-turn-lead',
      category: 'turn',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526394,
      title: 'Assessment | Turn | Check-Raising Strategies',
      post_name: 'assessment-turn-check-raising-strategies',
      category: 'turn',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526425,
      title: 'Assessment | Turn | Adjustments &#038; Exploits',
      post_name: 'assessment-turn-adjustments-exploits',
      category: 'turn',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526295,
      title: 'Assessment | Turn | Betting Strategies',
      post_name: 'assessment-turn-betting-strategies',
      category: 'turn',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526457,
      title: 'Assessment | River | Bet Size Adjustments',
      post_name: 'assessment-river-bet-size-adjustments',
      category: 'river',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526490,
      title: 'Assessment | River | Bluffing',
      post_name: 'assessment-river-bluffing',
      category: 'river',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526523,
      title: 'Assessment | River | Betting Strategies 1',
      post_name: 'assessment-river-betting-strategies-1',
      category: 'river',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526556,
      title: 'Assessment | River | Betting Strategies 2',
      post_name: 'assessment-river-betting-strategies-2',
      category: 'river',
      started: false,
      questions_count: 0,
    },
    {
      quiz_id: 2526587,
      title: 'Assessment | River | Facing a Bet',
      post_name: 'assessment-river-facing-a-bet',
      category: 'river',
      started: false,
      questions_count: 0,
    },
  ]
}
